import {
  GroupCheckInLayout,
  GroupDetailLayout,
  GroupEditLayout,
  GroupSessionNoteLayout,
  GroupVisitLayout,
} from "@/pages/app/provider/group-visit";
import { GroupAppointmentList } from "@/pages/app/provider/scheduling/group-appointment";
import lazyRoute from "@/router/lazy-route";
import { ProtectedRoute } from "@/router/Router";
import { Help } from "@mui/icons-material";
import { Outlet, Route } from "react-router-dom";
import { PatientFlagList } from "./provider-lazy-routes";
import { BillingRoutes } from "./routes/BillingRoutes";
import { PatientChartRoutes } from "./routes/PatientChartRoutes";
import { SettingsRoutes } from "./routes/SettingsRoutes";

const ProviderCatalog = lazyRoute(
  () => import("@/components/app/provider/lib/ProviderCatalog")
);
const ProviderDataImport = lazyRoute(
  () => import("@/components/app/provider/lib/ProviderDataImport")
);
const EducationLayout = lazyRoute(
  () =>
    import("@/components/app/provider/lib/education-material/EducationLayout")
);
// const ProviderFormBuilderHost = lazyRoute(
//   () =>
//     import("@/components/app/provider/lib/form-builder/ProviderFormBuilderHost")
// );
// const ProviderFormBuilderTable = lazyRoute(
//   () =>
//     import("@/components/app/provider/lib/form-builder/ProviderFormBuilderTable")
// );
const ProviderTemplateHost = lazyRoute(
  () => import("@/components/app/provider/lib/template/ProviderTemplateHost")
);
const ProviderTemplateTable = lazyRoute(
  () => import("@/components/app/provider/lib/template/ProviderTemplateTable")
);
const ProviderPortalLayout = lazyRoute(
  () => import("@/layout/app/provider/ProviderPortalLayout")
);
const CatalogCPTCodeCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogCPTCodeCatalog")
);
const CatalogDiagnosisCodeCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogDiagnosisCodeCatalog")
);
const CatalogDrugCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogDrugCatalog")
);
const CatalogHCPCSCodeCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogHCPCSCodeCatalog")
);
const CatalogLOINCCodeCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogLOINCCodeCatalog")
);
const RefillRequests = lazyRoute(
  () => import("@/pages/app/provider/collaboration/RefillRequests")
);
const Results = lazyRoute(
  () => import("@/pages/app/provider/collaboration/Results")
);
const OpenEncounters = lazyRoute(
  () =>
    import("@/pages/app/provider/collaboration/open-encounter/OpenEncounters")
);
const CollaborationLayout = lazyRoute(
  () => import("@/pages/app/provider/collabration/CollaborationLayout")
);
const PatientInquiries = lazyRoute(
  () =>
    import("@/pages/app/provider/collabration/patient-inquiries/PatientInquiries")
);
const Referrals = lazyRoute(
  () => import("@/pages/app/provider/collabration/referrals/Referrals")
);
const Tasks = lazyRoute(
  () => import("@/pages/app/provider/collabration/tasks/Tasks")
);
const CommunicationLayout = lazyRoute(
  () => import("@/pages/app/provider/communications/CommunicationLayout")
);
const ContactDictionary = lazyRoute(
  () =>
    import("@/pages/app/provider/communications/contact-dictionary/ContactDictionary")
);
const EmailTable = lazyRoute(
  () => import("@/pages/app/provider/communications/email/EmailTable")
);
const SmsText = lazyRoute(
  () => import("@/pages/app/provider/communications/messages/SmsText")
);
const Dashboard = lazyRoute(
  () => import("@/pages/app/provider/dashboard/Dashboard")
);
const EditPatient = lazyRoute(
  () => import("@/pages/app/provider/patient/EditPatient")
);
const PatientLayout = lazyRoute(
  () => import("@/pages/app/provider/patient/PatientLayout")
);
const ConsentForms = lazyRoute(
  () => import("@/pages/app/provider/patient/patient-list/ConsentForms")
);
const PatientList = lazyRoute(
  () => import("@/pages/app/provider/patient/patient-list/PatientList")
);
const BillingReports = lazyRoute(
  () => import("@/pages/app/provider/reports/BillingReports")
);
const ReportsLayout = lazyRoute(
  () => import("@/pages/app/provider/reports/ReportsLayout")
);
const AppointmentScheduling = lazyRoute(
  () =>
    import("@/pages/app/provider/scheduling/appointment/AppointmentScheduling")
);
const Availability = lazyRoute(
  () => import("@/pages/app/provider/scheduling/availability/Availability")
);
const Assessments = lazyRoute(
  () => import("@/pages/app/provider/collabration/assessments/Assessments")
);
const Chat = lazyRoute(
  () => import("@/pages/app/provider/communications/chat/Chat")
);
const FaxLayout = lazyRoute(
  () => import("@/pages/app/provider/communications/fax/FaxLayout")
);
const IncomingFax = lazyRoute(
  () => import("@/pages/app/provider/communications/fax/IncomingFax")
);
const OutgoingFax = lazyRoute(
  () => import("@/pages/app/provider/communications/fax/OutgoingFax")
);
const SchedulingLayout = lazyRoute(
  () => import("@/pages/app/provider/scheduling/SchedulingLayout")
);
const VisitNoteTemplateLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/settings/practice-setting/visit-note-template/VisitNoteTemplateLayout")
);

// import PatientSms from "../../pages/app/provider/patient/patient-list/patient-chart-new/communication/PatientSms";
// import ClaimIntegrationList from "../../pages/app/provider/settings/claim-integration/ClaimIntegrationList";
// import PatientVisitNoteLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/PatientVistNoteLayout";

export const ProviderRoute = () => {
  return (
    <Route
      path="provider"
      element={
        <ProtectedRoute accessingViewAs="provider">
          <ProviderPortalLayout />
        </ProtectedRoute>
      }
    >
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="group-visit" element={<GroupVisitLayout />} />
      <Route
        path="group-visit/:groupVisitId/edit"
        element={<GroupEditLayout />}
      />
      <Route
        path="group-visit/:groupVisitId/view"
        element={<GroupEditLayout readOnly />}
      />
      {/* Static segments outrank :groupVisitId, so check-in, session-note and
          edit keep their own routes. */}
      <Route path="group-visit/:groupVisitId" element={<GroupDetailLayout />} />
      <Route
        path="group-visit/:groupVisitId/:tab"
        element={<GroupDetailLayout />}
      />
      <Route path="group-visit/check-in" element={<GroupCheckInLayout />} />
      <Route
        path="group-visit/session-note/:patientId?"
        element={<GroupSessionNoteLayout />}
      />
      <Route path="scheduling" element={<SchedulingLayout />}>
        <Route path="appointment" element={<AppointmentScheduling />} />
        <Route path="appointment/group" element={<GroupAppointmentList />} />
        <Route path="availability" element={<Availability />} />
      </Route>

      <Route path="patients" element={<PatientLayout />}>
        <Route index element={<PatientList />} />
        <Route path="new-patient" element={<Outlet />}>
          {PatientChartRoutes()}
        </Route>

        {/* <Route path="add-patient" element={<AddPatient />} /> */}
        <Route path="edit-patient/:patientId" element={<EditPatient />} />
        <Route path="consent-forms" element={<ConsentForms />} />
        <Route path="flags" element={<PatientFlagList />} />
      </Route>

      <Route path="communications" element={<CommunicationLayout />}>
        <Route index element={<SmsText />} />
        <Route path="chat" element={<Chat />} />
        <Route path="email" element={<EmailTable />} />
        <Route path="dictionary" element={<ContactDictionary />} />
        <Route path="fax" element={<FaxLayout />}>
          <Route index element={<IncomingFax />} />
          <Route path="outgoing-fax" element={<OutgoingFax />} />
          {/* <Route path="fax-folder" element={<FaxFolder />} /> */}
        </Route>
      </Route>

      <Route path="collaboration" element={<CollaborationLayout />}>
        <Route path="tasks" element={<Tasks />} />
        <Route path="referrals" element={<Referrals />} />
        <Route path="patient-inquiries" element={<PatientInquiries />} />
        <Route path="refill-request" element={<RefillRequests />} />
        <Route path="results" element={<Results />} />
        <Route path="open-encounters" element={<OpenEncounters />} />
        <Route path="assessments" element={<Assessments />} />
      </Route>

      {BillingRoutes()}
      <Route path="reports" element={<ReportsLayout />}>
        <Route path="billing-report" element={<BillingReports />} />
      </Route>
      <Route path="library">
        <Route index element={<ProviderDataImport />} />
        <Route path="catalog" element={<ProviderCatalog />}>
          <Route index element={<CatalogLOINCCodeCatalog />} />
          <Route path="drug-catalog" element={<CatalogDrugCatalog />} />
          <Route
            path="diagnosis-catalog"
            element={<CatalogDiagnosisCodeCatalog />}
          />
          <Route path="cpt-code-catalog" element={<CatalogCPTCodeCatalog />} />
          <Route
            path="hcpcs-code-catalog"
            element={<CatalogHCPCSCodeCatalog />}
          />
        </Route>
        {/* <Route path="form-builder" element={<ProviderFormBuilderTable />} />
        <Route path="form-builder-host" element={<ProviderFormBuilderHost />} /> */}
        <Route path="templates" element={<ProviderTemplateTable />} />
        <Route path="templates-host" element={<ProviderTemplateHost />} />
        <Route path="education-material" element={<EducationLayout />} />
        <Route path="visit-templates" element={<VisitNoteTemplateLayout />} />
      </Route>
      {SettingsRoutes()}
      <Route path="help" element={<Help />} />
    </Route>
  );
};

// unread message
